import pages from './pages'
import forms from './forms'
import users from './users'
import transact from './transact'
import uploads from './uploads'
import menu from './menu'
import accessRequests from './accessRequests'
import analytics from './analytics'

// Two data layers (see plugins/api.js):
//   v2 → api.ltng.app/v2, account e7b8b3ee — the modules MANAGED in the V3
//        manager: CMS pages (+ the menu derived from them) and Transact products.
//   v1 → api.ltng.app, account 7a3d3b52 — everything else, kept on the working
//        legacy account (the V2 account 500s "Module not active." for
//        access-requests/analytics and is unverified for the authed flows).
export default function (v2, v1) {
  return {
    // Managed in V3 → V2
    pages: pages(v2),
    menu: menu(v2),
    // Legacy, kept working → V1
    forms: forms(v1),
    users: users(v1),
    transact: transact(v2, v1), // products → V2; orders/customers → V1
    uploads: uploads(v1),
    accessRequests: accessRequests(v1),
    analytics: analytics(v1),
    $client: v2,
    $clientV1: v1,
  }
}
